import basic from "./basic.json";
import layout from "./layout.json";
import eventTypeString from "./eventTypeString.json";
import eventReport from "./eventReport.json";
import login from "../../pages/Login/locales/en.json";
import fleetMap from "../../pages/FleetMap/locales/en.json";
import eventCenter from "../../pages/EventCenter/locales/en.json";
import playback from "../../pages/Playback/locales/en.json";
import settings from "../../pages/Settings/locales/en.json";
import liveStream from "../../pages/LiveStream/locales/en.json";
import installApp from "../../components/InstallAppButton/locales/en.json";
import notifications from "../../pages/Notifications/locales/en.json";
import home from "../../pages/Home/locales/en.json";
import periodicReport from "../../pages/PeriodicReport/locales/en.json";
import changePassword from "../../pages/ChangePassword/locales/en.json";

export const en = {
  ...basic,
  ...layout,
  ...eventTypeString,
  ...eventReport,
  ...login,
  ...fleetMap,
  ...eventCenter,
  ...playback,
  ...settings,
  ...liveStream,
  ...installApp,
  ...notifications,
  ...home,
  ...periodicReport,
  ...changePassword,
};
